export default __webpack_public_path__ + "assets/no-comments-02@3x.png";